import React from 'react';

import { CircleButton } from 'ui/component';
import { StyleUtil } from 'ui/util';
import classNames from './EABDJourneyHighlightedCircleButton.module.scss';

export interface JourneyHighlightedCircleButtonProps
  extends Readonly<{
    isVisible: boolean;
    arrowDirection: 'left' | 'right';
  }> {}

export const JourneyHighlightedCircleButton = React.memo<JourneyHighlightedCircleButtonProps>((props) => {
  const { isVisible, arrowDirection } = props;

  const CointainerClassNames = React.useMemo(() => {
    const cointainerClassNames: string[] = [classNames.container];

    switch (arrowDirection) {
      case 'left':
        cointainerClassNames.push(classNames.left);
        break;
      case 'right':
        cointainerClassNames.push(classNames.right);
        break;
    }

    return StyleUtil.mergeClassNames(cointainerClassNames);
  }, [arrowDirection]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={CointainerClassNames}>
      <div className={classNames.outline}>
        <CircleButton arrowDirection={arrowDirection} onPress={() => undefined} isStatic={true} />
      </div>
    </div>
  );
});
